import { UserStore } from 'store/user/types.ts'

export const initialUserState: UserStore = {
  error: false,
  loading: false,
  logins: [],
  users: []
}
